import React, {
    createContext,
    ReactNode,
    useCallback,
    useMemo,
    useState,
} from "react";
import { ContentGetItemResponse } from "../constants/types";

interface State {
    openModalDetailBarang: (data: ContentGetItemResponse) => void;
    closeModalDetailBarang: () => void;
    data: ContentGetItemResponse;
    isOpenModalDetailBarang: boolean;
}

interface IDetailBarangModalContext {
    children: ReactNode;
}

const DetailBarangModalContext = createContext<State | undefined>(undefined);

const DetailBarangModalProvider = ({ children }: IDetailBarangModalContext) => {
    const [isOpenModalDetailBarang, setIsOpenModalDetailBarang] =
        useState(false);
    const [data, setData] = useState<ContentGetItemResponse>({
        id: 0,
        nomer: 0,
        namaBarang: "",
        deskripsi: "",
        sku: "",
        kategori: {
            id: 0,
            nama: "",
        },
        warehouse: {
            id: 0,
            nama: "",
        },
        gambar: "",
        multipleGambar: [],
        harga: 0,
        isActiveStok: false,
        favorite: 0,
        stok: 0,
        isBundling: 0,
        itemSatuan: null,
        isShow: "",
        detailBundling: [],
        hargaMultiple: [],
        isSet: 0,
        isPusat: 0,
        expAt: null,
        hpp: [],
        stokPusat: 0,
        terjual: 0,
    });

    const openModalDetailBarang = useCallback(
        (data: ContentGetItemResponse) => {
            setIsOpenModalDetailBarang(true);
            setData(data);
        },
        [],
    );

    const closeModalDetailBarang = useCallback(() => {
        setIsOpenModalDetailBarang(false);
        // setDeskripsi("");
    }, []);

    const value = useMemo(
        () => ({
            openModalDetailBarang,
            isOpenModalDetailBarang,
            closeModalDetailBarang,
            data,
        }),
        [
            openModalDetailBarang,
            isOpenModalDetailBarang,
            closeModalDetailBarang,
            data,
        ],
    );
    return (
        <DetailBarangModalContext.Provider value={value}>
            {children}
        </DetailBarangModalContext.Provider>
    );
};

const useDetailBarangModal = () => {
    const context = React.useContext(DetailBarangModalContext);
    if (context === undefined) {
        throw new Error(
            "useDetailBarangModal must be used within a DetailBarangModalProvider",
        );
    }
    return context;
};

export {
    DetailBarangModalContext,
    DetailBarangModalProvider,
    useDetailBarangModal,
};
